export enum PropertyFitoutsDoneBy {
  Tenant = 'Tenant',
  Developer = 'Developer',
}
